import { render, staticRenderFns } from "./ParlamentarItemList.vue?vue&type=template&id=718e070e&scoped=true&"
import script from "./ParlamentarItemList.vue?vue&type=script&lang=js&"
export * from "./ParlamentarItemList.vue?vue&type=script&lang=js&"
import style0 from "./ParlamentarItemList.vue?vue&type=style&index=0&id=718e070e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "718e070e",
  null
  
)

export default component.exports